

export function getLanguageRoute (route = '') {
  return `:languageId/${route}`
}

export function getPageRoute (route = '') {
  return getLanguageRoute(`:pageName/${route}`)
}

export function getGroupRoute (route = '') {
  return `:groupId/${route}`
}

export function getUnitsRoute (route = '') {
  return getPageRoute(getGroupRoute(`units/:unitId/${route}`))
}

export const routes = {
  language:'/:languageId',
  schedule:'/:languageId/schedule',
  scheduleView:'/:languageId/schedule/:scheduleView',
  page:'/:languageId/:pageName',
  group:'/:languageId/:pageName/:groupId',
  section:'/:languageId/:pageName/:groupId/:section',
  units:'/:languageId/:pageName/:groupId/units/:unitId',
  assessment:'/:languageId/:pageName/:groupId/assessment/:assessmentId',
  homework:'/:languageId/:pageName/:groupId/homework/:homeworkId',
  assessmentSection:'/:languageId/:pageName/:groupId/assessment/:assessmentId/:sectionId',
  assessmentQuestion:'/:languageId/:pageName/:groupId/assessment/:assessmentId/:sectionId/:questionId',
  gradebook:'/:languageId/gradebook/:groupId'
}